<template>
  <v-container fluid grid-list-xl pa-0 style="position: relative">
    <Toolbar
      :searchData="searchData"
      :productsCount="productsCount"
      :dataOfClients="dataOfClients"
      @showProductList="productList()"
    />
    <ProductActions
      v-if="selectedProductList.length"
      ref="productActions"
      :trackIds="trackIds"
      :productInfo="productInfo"
      :dataOfClients="dataOfClients"
      :deleteUrlPayload="deleteUrlPayload"
      :selectedProductList="selectedProductList"
      @deleteLinks="deleteSelectedLinks"
      @moveLinks="moveLinks"
    />
    <!--    Filters       -->
    <template>
      <ProductFilter
        :loading="loading"
        :sellerIds="sellerIds"
        :domainIds="domainIds"
        :clientId="clientId"
        :clientSelected="clientSelected"
        @selectedClient="selectedClient"
        @selectedSellers="selectedSellers"
        @selectedDomains="selectedDomains"
        @loadProducts="loadProducts"
      />
      <v-btn text color="red" class="m-w mb-1" @click="loadProduct(33818)">
        test
      </v-btn>
      <v-btn
        text
        :ripple="false"
        class="add-new-product ex-btn ex-primary-btn custom_button mt-1"
        @click="() => addNewProduct('new')"
      >
        <v-icon>add</v-icon>
        Add product
      </v-btn>
    </template>
    <!--    Tables-->
    <template v-if="invalidUrls.hasInvalid">
      <Table
        :validUrls="tableData"
        :invalidUrls="invalidUrls"
        @resolveConflicts="resolve"
        @productSaved="productSaved"
        :clientsID="dataOfClientsID"
        :productState="productState"
        :selectedProductList="selectedProductList"
      />
    </template>

    <template v-if="!selectedProduct && resolveData.merge_container">
      <ResolveConflictTable
        :resolveData="resolveData"
        :productName="productName"
        @saveConflictTable="saveConflictUrl"
        @resetConflictTable="reset()"
      />
    </template>
    <!--   Product Table -->
    <ProductDetailsHeader
      v-if="selectedProductList.length"
      :totalSelectedProducts="totalSelectedProducts"
      :dataOfClients="dataOfClients"
      :chosenProducts="chosenProducts"
      @updateSelectedProduct="updateSelectedProduct"
    />

    <ProductTable
      v-if="selectedProductList.length && !invalidUrls.hasInvalid"
      :selectedProductList="selectedProductList"
      :selectVariation="selectVariation"
      :trackIds="trackIds"
      :urlIds="urlIds"
      :productInfo="productInfo"
      :productsData="productsData"
      :deleteUrlPayload="deleteUrlPayload"
      @loadProduct="loadProduct"
      @parentProduct="parentProduct"
      @extractProduct="extractProduct"
      @chooseProduct="chooseProduct"
      @showNextProduct="loadProduct"
      @showPreviousProduct="loadProduct"
      @deleteLinks="deleteSelectedLinks"
      @filterDomainSellers="filterDomainSellers"
      @createPayloadLinkFromClients="createPayloadLinkFromClients"
      @removeProductFromSelected="removeProductFromSelected"
      @addUrlToProduct="() => addNewProduct('addition')"
    />
    <!--   Not Found   -->
    <ex-not-found
      title="No Product selected"
      reference="Create Product"
      v-if="!addProductUrl && !selectedProductList.length"
      @click="addNewProduct()"
    />
    <!--   Dialogs-->
    <v-dialog v-model="showDialogData" width="800">
      <v-card>
        <v-card-title class="headline" dark-title> Insert URL </v-card-title>
        <v-card-text class="mb-3">
          <v-layout row justify-end>
            <v-flex xs3>
              <p v-if="!resetFlag" class="text-xs-right">
                <v-btn
                  text
                  color="red"
                  class="m-w"
                  @click="resetFlag = !resetFlag"
                >
                  <v-icon>replay</v-icon>Reset
                </v-btn>
              </p>
              <p v-else class="subtitle-1" dark-title>
                Reset:
                  <v-btn small class="green" @click="resetUrls(); resetFlag = !resetFlag">
                    <v-icon>done</v-icon>
                  </v-btn>
                  <v-btn small class="red" @click="resetFlag = !resetFlag">
                    <v-icon>close</v-icon>
                  </v-btn>
              </p>
            </v-flex>
            <v-flex xs3>
              <p class="text-xs-right">
                <v-btn
                  text
                  color="primary"
                  class="m-w"
                  @click="addNewProductUrl()"
                >
                  <v-icon>add</v-icon>
                  Add url
                </v-btn>
              </p>
            </v-flex>
          </v-layout>
          <div class="add_url-wrapper">
            <div v-for="(item, key) in urlInfo" :key="key" class="add_url">
              <v-layout row justify-space-between align-end>
                <v-flex xs2>
                  <p class="mb-2">Color:</p>
                  <v-select
                    v-model="urlInfo[key].color"
                    :items="dataColor"
                    label="color"
                    class="ex-variation-dropdown ex-opacity-btn"
                    item-text="value"
                    item-value="id"
                    solo
                  >
                  </v-select>
                </v-flex>
                <v-flex xs2>
                  <p class="mb-2">Size:</p>
                  <v-select
                    v-model="urlInfo[key].size"
                    :items="dataSize"
                    label="size"
                    class="ex-variation-dropdown ex-opacity-btn"
                    item-text="value"
                    item-value="id"
                    solo
                  >
                  </v-select>
                </v-flex>
                <v-flex xs6 class="d-flex">
                  <v-text-field
                    v-model="urlInfo[key].value"
                    class="i-v-input"
                    prepend-inner-icon="link"
                    label="Product Link"
                    single-line
                    solo
                  ></v-text-field>
                  <v-btn
                    text
                    :disabled="urlInfo.length === 1"
                    class="ex-btn"
                    @click="deleteRow(key)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :ripple="false"
            :loading="loading"
            class="ma-0 ex-btn ex-primary-btn text--white"
            @click="saveProductLink()"
          >
            Validate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showProductTable"
      width="1200"
      class="product-list-modal"
    >
      <ProductListTable
        :clientName="clientName"
        :productsData="productsData"
        @loadProduct="loadProduct"
        @deleteRowOfProductList="deleteRowOfProductList"
      />
    </v-dialog>
    <notifications group="save" position="top center" :max="3" width="350">
      <template slot="body" slot-scope="props">
        <div class="default-notification save-notification">
          <a class="close" @click="props.close">
            <v-icon>close</v-icon>
          </a>
          <a class="title">
            {{ props.item.title }}
          </a>
          <p v-html="props.item.text"></p>
        </div>
      </template>
    </notifications>
  </v-container>
</template>

<script>
/* eslint-disable */
import Table from "../components/product/Table";
import ResolveConflictTable from "../components/product/ResolveConflictTable";
import SelectionDialog from "../components/product/SelectionDialog";
import Toolbar from "../components/product/Toolbar";
import ProductActions from "../components/product/ProductActions";
import ProductTable from "../components/product/ProductTable";
import ProductFilter from "../components/product/ProductFilter";
import ProductListTable from "../components/product/ProductListTable";
import ProductDetailsHeader from "../components/product/ProductDetailsHeader";
import { productDetailsBus } from "@/helpers/buses.js";

export default {
  name: "Products",
  components: {
    ProductDetailsHeader,
    Table,
    SelectionDialog,
    Toolbar,
    ProductActions,
    ResolveConflictTable,
    ProductTable,
    ProductFilter,
    ProductListTable,
  },
  data: () => ({
    selectVariation: [],
    selectVariationForRow: [],
    productInfo: {},
    showConfirmAlert: false,
    selectedProductList: [],
    initialSelectedProduct: [],
    clientName: "",
    clientId: null,
    showProductTable: false,
    productsData: [],
    productsCount: 0,
    searchData: {
      sidebar: {
        show: false,
      },
      brand: {
        isLoading: false,
        items: [],
        model: null,
        search: null,
      },
      category: {
        isLoading: false,
        items: [],
        model: null,
        search: null,
      },
      title: {
        isLoading: false,
        items: [],
        model: null,
        search: null,
      },
      client: {
        isLoading: false,
        items: [],
        model: null,
        search: null,
      },
      ean: {
        isLoading: false,
        items: [],
        model: null,
        search: null,
      },
      sko: false,
      flag: false,
      dialogData: {
        show: false,
        contentIsLoading: false,
      },
    },
    productName: "",
    categoryName: "",
    loading: false,
    dataOfClients: [{ value: "0", text: "No client" }],
    dataOfClientsID: 0,
    clientSelected: false,
    sellerIds: [],
    domainIds: [],
    sellerInvert: false,
    chips: [],
    domains: [],
    dataTranslations: [],
    dataColor: [],
    dataSize: [],
    selectedProduct: false,
    showDialogData: false,
    urlInfo: [
      {
        color: 0,
        size: 0,
        value: "",
      },
    ],
    productState: {
      state: "new",
      product_id: 0,
    },
    filters: {
      brand: {
        isLoading: false,
        search: null,
      },
      category: {
        isLoading: false,
        search: null,
      },
      product: {
        isLoading: false,
        search: null,
      },
      sku: {
        isLoading: false,
        search: null,
      },
      allowRequest: true,
    },
    trackIds: [],
    urlIds: [],
    totalSelectedProducts: 0,
    chosenProducts: [],
    deleteUrlPayload: {
      product_ids: [],
      url_ids: [],
      track_ids: [],
    },
    resetFlag: false,
  }),
  created() {
    this.gettingClients();
    this.gettingVariations();
  },
  methods: {
    parentProduct(id) {
      //  alert(id)
      this.loadProduct(id);
    },
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
      this.domains.splice(this.domains.indexOf(item), 1);
      this.domains = [...this.domains];
    },
    unChecked() {
      const input = document.querySelectorAll(".custom-checkbox");
      input.forEach((el) => {
        el.checked = false;
      });
      this.deleteUrlPayload = {
        product_ids: [],
        url_ids: [],
        track_ids: [],
      };
    },
    deleteUrl(item, index, linkId) {
      let trackIds = [];
      trackIds.push(
        this.selectedProductList.tracks[index].urls[linkId].track_id
      );
      let obj = {
        product_id: this.productInfo.product_id,
        track_ids: trackIds,
      };
      this.$store.dispatch("productModule/removeTrack", obj).then((res) => {
        if (res) {
          this.selectedProductList.tracks[index].urls.splice(linkId, 1);
          if (this.selectedProductList.tracks[index].urls.length < 1) {
            this.selectedProductList.tracks.splice(index, 1);
          }
        }
      });
    },
    deleteSelectedLinks() {
      this.$store
        .dispatch("productModule/unlinkUrl", this.deleteUrlPayload)
        .then(() => {
          this.deleteLinkFromRow();
          this.trackIds = [];
          this.unChecked();
        });
    },
    deleteLinkFromRow() {
      let trackId = this.trackIds;
      for (let i = 0; i < trackId.length; i++) {
        this.selectedProductList.tracks.map((el) => {
          let index = this.selectedProductList.tracks.indexOf(el);
          el.urls.map((elem) => {
            let linkIndex = el.urls.indexOf(elem);
            if (elem.track_id === trackId[i]) {
              this.selectedProductList.tracks[index].urls.splice(linkIndex, 1);
              if (this.selectedProductList.tracks[index].urls.length < 1) {
                this.selectedProductList.tracks.splice(index, 1);
              }
              return false;
            }
          });
        });
      }
    },
    moveLinks(productId) {
      const obj = {
        target_product_id: productId.product_id,
        tracks_ids: this.trackIds,
      };
      this.$store.dispatch("productModule/moveLinks", obj).then(() => {
        this.deleteLinkFromRow();
        this.trackIds = [];
        this.unChecked();
        this.$refs.productActions.moveDialog = false;
        this.$refs.productActions.productMoved();
      });
    },
    loadProduct(productId) {
      // this.$store.commit('productModule/SET_CLEAR_URLS_CONTAINER')
      this.trackIds = [];
      this.selectedProductList = [];
      this.initialSelectedProduct = [];
      this.totalSelectedProducts = 0;
      this.productInfo = {
        product_id: productId,
        client_id: this.clientId,
      };
      let obj = {
        product_id: [productId],
      };
      this.$store.dispatch("productModule/loadProduct", obj).then((res) => {
        this.selectedProductList = res.data;
        this.initialSelectedProduct = JSON.parse(JSON.stringify(res.data));
        this.showProductTable = false;
        this.selectVariationForRow = this.dataColor;
        this.totalSelectedProducts = this.selectedProductList.length;
        console.log("loadProduct", res);
      });
    },
    productList() {
      this.showProductTable = true;
    },
    deleteRowOfProductList(index, item) {
      this.dialog = true;
      this.showConfirmAlert = true;
      this.productInfo = {
        product_id: item.product_id,
        client_id: this.clientId,
      };
    },
    loadProducts() {
      this.loading = true;
      this.selectedProductList = [];
      const data = {
        filters: {
          clientFilter: this.clientId,
          sellerFilter: this.sellerIds,
          domainFilter: this.domainIds,
          productStatus: this.$store.state.productModule.selectedFilters.list,
          brandFilter: this.$store.state.productModule.selectedFilters.brand,
          nameFilter: this.$store.state.productModule.selectedFilters.product,
          categoryFilter:
            this.$store.state.productModule.selectedFilters.category,
          skuFilter: this.$store.state.productModule.selectedFilters.sku,
          eanFilter: this.$store.state.productModule.selectedFilters.ean,
        },
      };
      this.$store.dispatch("productModule/getProductList", data).then((res) => {
        if (res.data.toString().trim() != "task found") {
          this.productsData = res.data;
          this.productsCount = res.data.length;
          this.loading = false;
          this.sellerIds = [];
          this.domainIds = [];
        } else {
          this.productsData = [];
          this.productsCount = 0;
          this.loading = false;
          this.sellerIds = [];
          this.domainIds = [];
        }
      });
    },
    selectedClient(clientId) {
      let clientText = this.dataOfClients.filter((el) => el.value === clientId);
      this.clientName = clientText[0].text;
      this.clientId = clientId;
      this.clientSelected = clientText[0].value !== "0";
    },
    selectedSellers(items) {
      this.sellerIds = [];
      items.forEach((item) => this.sellerIds.push(+item.id));
    },
    selectedDomains(items) {
      this.domainIds = [];
      items.forEach((item) => this.domainIds.push(+item.id));
    },
    reset() {
      this.$store.commit("productModule/SET_CONFLICT_URLS", {});
      this.selectedProduct = true;
    },
    saveConflictUrl(data) {
      this.$store
        .dispatch("productModule/saveConflictUrl", data)
        .then((res) => {
          if (!res.data.error) {
            // this.deleteDuplicateProduct(data.conflict)

            this.deleteDuplicateProduct(
              data.product_conflict.product_info.product_id
            );
            if (this.$store.state.productModule.RCurlInfo.length > 0) {
              this.$store.commit("productModule/SET_URLSET", true);
              this.saveProductLink();
            }
            // exit conflict + load productDetailsHeader + load ProdTable
            this.$store.commit("productModule/SET_DELETE_URLS", []);
            this.selectedProduct = true;
            this.invalidUrls.hasInvalid = false ;
            // ---
          }
        });
    },
    deleteDuplicateProduct(conflictProductID) {
      console.log("duplicate here", this.tableData);
      for (let item in this.tableData.invalid_duplicate) {
        if (
          this.tableData.invalid_duplicate[item].product_id ===
          conflictProductID
        ) {
          let elemIndex = this.tableData.invalid_duplicate.indexOf(
            this.tableData.invalid_duplicate[item]
          );
          this.$store
            .dispatch("productModule/deleteResolvedProduct", elemIndex)
            .then(() => {
              this.selectedProduct = true;
            });
        }
      }
    },
    gettingClients() {
      this.$store.dispatch("productModule/gettingClients").then((res) => {
        Array.from(res.data.clients).forEach((item) =>
          this.dataOfClients.push(item)
        );
      });
    },
    gettingVariations() {
      this.$store.dispatch("productModule/gettingVariations").then((res) => {
        console.log("gettingVariations", res);
        this.selectVariation = [];
        //  Variation color,size dropdowns,keys as column selection
        Object.entries(res.data.variations).forEach((options) => {
          let idx = options[0];
          let values = options[1];
          this.selectVariation.push(idx);
          Array.from(values).forEach((value) => {
            switch (idx) {
              case "color":
                this.dataColor.push(value);
                break;
              case "size":
                this.dataSize.push(value);
                break;
            }
          });
        });
        if (this.selectVariation.length > 0) {
          this.selectedVariationIs = this.selectVariation[0];
        }
        // Detailed variation table
        Array.from(res.data.translations).forEach((item) =>
          this.dataTranslations.push(item)
        );
      });
    },
    close() {
      this.showDialogData = false;
    },
    saveProductLink() {
      //this.$store.commit("productModule/SET_SEC_SHOW", true);

      // @param type: addition || new
      console.log("prinurls", this.urlInfo);

      if (this.$store.state.productModule.RCurlbool == true) {
        this.urlInfo = this.$store.state.productModule.RCurlInfo;
        console.log("metaurls", this.urlInfo);
        this.$store.commit("productModule/SET_URLINFO", []);
        this.$store.commit("productModule/SET_URLSET", false);
      } //else {
      //  this.$store.commit("productModule/SET_URLINFO", this.urlInfo);

      // }

      this.loading = true;
      const obj = {
        urlInfo: this.urlInfo,
        productInfo: this.productState,
      };
      console.log("REQUEST___________։", obj);
      this.$store.dispatch("productModule/validate", obj).then(() => {
        console.log(this.tableData, "eee");
        console.log(this.invalidUrls, "error");
        console.log(this.productState.state, "stateeeeeeeeee");
        if (!this.invalidUrls.hasInvalid) {
          if (this.countnewUrl == 0) {
            this.trackIds = [];
            this.totalSelectedProducts = 0;
            this.selectedProductList = [this.tableData];
            this.initialSelectedProduct = JSON.parse(
              JSON.stringify(this.tableData)
            );
            this.productInfo = {
              product_id: "",
              client_id: this.clientId,
            };
            this.showProductTable = false;
            this.selectVariationForRow = this.dataColor;
            this.totalSelectedProducts = this.selectedProductList.length;
            this.$store.commit("productModule/SET_SHOW", true);
          }
        }
        if (this.invalidUrls.hasInvalid) {
          // if (typeof this.selectedProductList[0] !== "undefined") {
          if (
            (!!this.selectedProductList[0] ) &&
            (this.selectedProductList[0].product_domains.length > 0) &&
            (this.$store.state.productModule.pr_type == "addition")
          ) {
            //alert('ok')
            console.log("urls", this.selectedProductList[0].product_domains);
            this.$store.commit(
              "productModule/SET_EXIST_PRODUCT",
              this.selectedProductList[0].product_domains
            );
            this.$store.commit("productModule/SET_PR_TYPE", "");
          } else this.$store.commit("productModule/SET_EXIST_PRODUCT", []);
          // } else this.$store.commit("productModule/SET_EXIST_PRODUCT", []);
        }

        this.selectedProduct = true;
        this.showDialogData = false;
        this.$store.commit("productModule/SET_ADD_PRODUCT_URL", true);
        this.loading = false;
        if (this.isOpen) {
          this.$store.commit("sidebarModule/toggleSidebar");
        }
        this.urlInfo = [];
        this.urlInfo.push({
          color: 0,
          size: 0,
          value: "",
        });
      });
    },
    deleteRow(key) {
      if (this.urlInfo.length > 1) {
        this.urlInfo.splice(key, 1);
      }
    },
    resolve(productInfo) {
      this.productName = productInfo.product_name;
      this.selectedProduct = false;
      this.$store
        .dispatch("productModule/conflictResolve", productInfo)
        .then((data) => {
          console.log(this.resolveData, "NEED TO SHOW HERE");
        });
    },
    addNewProduct(type) {
      this.$store.commit("productModule/SET_PR_TYPE", type); // type ('new')
      this.productState.state = type;
      this.productState.product_id =
        type === "addition" ? this.productInfo.product_id : "";

      if (type === "addition" && this.productInfo.product_id > 0) {
        this.$store.commit(
          "productModule/SET_PRODUCT_ID",
          this.productInfo.product_id
        );
      }
      if (type != "addition") {
        this.$store.commit("productModule/SET_URLS", {});
      }

      this.showDialogData = true;
    },
    addNewProductUrl() {
      this.urlInfo.push({
        color: 0,
        size: 0,
        value: "",
      });
    },
    resetUrls () {
      this.urlInfo = [{
        color: 0,
        size: 0,
        value: "",
      }];
    },
    productSaved(productState) {
      let obj = {
        product_id: this.productState.product_id,
      };
      if (productState === "addition") {
        this.$store.dispatch("productModule/loadProduct", obj).then((res) => {
          this.selectedProductList = res.data.product;
        });
      }
      this.$notify({
        group: "save",
        title: "Product Saved",
        text: "Product saved!",
        duration: 500,
        speed: 600,
      });
    },
    chooseProduct(isChecked, productId) {
      if (isChecked) {
        this.totalSelectedProducts += 1;
        this.chosenProducts.push(productId);
        this.deleteUrlPayload.product_ids = this.chosenProducts;
        return;
      }
      this.totalSelectedProducts -= 1;
      this.chosenProducts = this.chosenProducts.filter(
        (id) => id !== productId
      );
      this.deleteUrlPayload.product_ids = this.chosenProducts;
    },
    updateSelectedProduct() {
      this.chosenProducts = [];
      const checkboxes = document.querySelectorAll(".product_checkbox");
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
      this.loadProduct(this.productInfo.product_id);
    },
    filterDomainSellers(clientSellers, index) {
      if (!clientSellers) {
        this.selectedProductList = JSON.parse(
          JSON.stringify(this.initialSelectedProduct)
        );
        return;
      }
      this.selectedProductList[index]["product_domains"].forEach((domains) => {
        domains["domain_urls"].forEach((urls) => {
          // eslint-disable-next-line eqeqeq
          urls.sellers = urls.sellers.filter((seller) =>
            clientSellers.some((id) => id == seller.seller_id)
          );
        });
      });
    },
    removeProductFromSelected(productId) {
      this.selectedProductList = this.selectedProductList.filter(
        (product) => product["product_info"].product_id !== productId
      );
      this.initialSelectedProduct = JSON.parse(
        JSON.stringify(this.selectedProductList)
      );
    },
    createPayloadLinkFromClients(trackId, urlId) {
      const indexOfTrack = this.deleteUrlPayload.track_ids.indexOf(trackId);
      const indexOfUrl = this.deleteUrlPayload.url_ids.indexOf(urlId);
      indexOfTrack < 0
        ? this.deleteUrlPayload.track_ids.push(trackId)
        : this.deleteUrlPayload.track_ids.splice(indexOfTrack, 1);
      indexOfUrl < 0
        ? this.deleteUrlPayload.url_ids.push(urlId)
        : this.deleteUrlPayload.url_ids.splice(indexOfUrl, 1);
    },
    extractProduct(payload) {
      this.$store.dispatch("productModule/extractProduct", payload).then(() => {
        console.log("NEW TABLE DATA", this.tableData);
        this.selectedProductList = [this.tableData];
        // this.initialSelectedProduct = JSON.parse(JSON.stringify(this.tableData))
        console.log("PRODUCT CREATE PAYLOAD", payload);
      });
    },
  },
  computed: {
    countnewUrl() {
      return Object.keys(this.$store.state.productModule.newToAdd).length;
    },
    newUrl() {
      return this.$store.state.productModule.newToAdd;
    },
    resolveData() {
      return this.$store.state.productModule.conflictContainer;
    },
    invalidUrls() {
      return this.$store.state.productModule.responseInvalidUrls;
    },
    tableData() {
      return this.$store.state.productModule.urlsContainer;
    },
    isOpen() {
      return this.$store.state.sidebarModule.isOpen;
    },
    addProductUrl: function () {
      return this.$store.state.productModule.addProductUrl;
    },
    showButton() {
      return this.$store.state.productModule.showButton;
    },
    getSelectedFilters () {
      return this.$store.state.productModule.selectedFilters
    }
  },
  updated() {
    productDetailsBus.$on("selectAll_ids", (is_Checked, track_ids, url_ids ) => {
      if (is_Checked) {
        this.deleteUrlPayload.url_ids = url_ids;
        this.deleteUrlPayload.track_ids = track_ids;
      } else {
        this.deleteUrlPayload.url_ids = [];
        this.deleteUrlPayload.track_ids = [];
      }
    });
    productDetailsBus.$on("selectDomain", (status, prod_id ) => {
      if(status) {
        if(!this.chosenProducts.includes(prod_id)){
          this.chosenProducts.push(prod_id);
        }
        if(!this.deleteUrlPayload.product_ids.includes(prod_id)) {
          this.deleteUrlPayload.product_ids.push(prod_id);
        }
      } else {
        if(this.chosenProducts.includes(prod_id)){
          let chosen_product_index = this.chosenProducts.indexOf(prod_id);
          this.chosenProducts.splice(chosen_product_index, 1);
        }
        if(this.deleteUrlPayload.product_ids.includes(prod_id) && this.deleteUrlPayload.track_ids.length === 0) {
          let product_index = this.deleteUrlPayload.product_ids.indexOf(prod_id);
          this.deleteUrlPayload.product_ids.splice(product_index, 1);
        }
      }
      
    });
    productDetailsBus.$on("selectSingleUrl", (status, link, prod_id) => {
      if(status){
        if(!this.chosenProducts.includes(prod_id)){
          this.chosenProducts.push(prod_id);
        }
        if(!this.deleteUrlPayload.product_ids.includes(prod_id)) {
          this.deleteUrlPayload.product_ids.push(prod_id);
        }
        if(!this.deleteUrlPayload.url_ids.includes(link.url_id)) {
          this.deleteUrlPayload.url_ids.push(link.url_id);
        }
        if(!this.deleteUrlPayload.track_ids.includes(link.sellers[0].track_id)) {
          this.deleteUrlPayload.track_ids.push(link.sellers[0].track_id);
        }
      } else {
        if(this.chosenProducts.includes(prod_id)){
          let chosen_product_index = this.chosenProducts.indexOf(prod_id);
          this.chosenProducts.splice(chosen_product_index, 1);
        }
        if(this.deleteUrlPayload.url_ids.includes(link.url_id)) {
          let url_index = this.deleteUrlPayload.url_ids.indexOf(link.url_id)
          this.deleteUrlPayload.url_ids.splice(url_index, 1);
        }
        if(this.deleteUrlPayload.track_ids.includes(link.sellers[0].track_id)) {
          let track_index = this.deleteUrlPayload.track_ids.indexOf(link.sellers[0].track_id);
          this.deleteUrlPayload.track_ids.splice(track_index, 1);
        }
        if(this.deleteUrlPayload.product_ids.includes(prod_id) && this.deleteUrlPayload.track_ids.length === 0) {
          let prod_index = this.deleteUrlPayload.product_ids.indexOf(prod_id);
          this.deleteUrlPayload.product_ids.splice(prod_index, 1);
        }
      }
    });
  },
}
</script>

<style scoped>
.add-new-product {
  position: absolute;
  right: 0%;
  /* top: 70px; */
}
</style>



// WEBPACK FOOTER //
// src/views/Product.vue